// src/api/search.ts
import type { ProductImage, ProductVariant } from '../types';
import { apiClient } from './client';

export interface SearchParams {
    q: string;
    category?: string;
    min_price?: number;
    max_price?: number;
    page?: number;
    page_size?: number;
}

export interface SearchResult {
    id: number;
    sku: string;
    title: string;
    description: string;
    selling_price: number;
    discounted_price: number;
    discount_percent: number | null;
    is_featured: boolean;
    rating: number | null;
    view_count: number;
    category_tags: string[];
    search_keywords: string[];
    available_quantity: number;
    relevance?: number;
    images?: ProductImage[];
    variants?: ProductVariant[];
    total_available_quantity?: number;
}

export const searchApi = {
    // Advanced search with typo tolerance
    advancedSearch: async (params: SearchParams) => {
        const response = await apiClient.get<{
            results: SearchResult[];
            count: number;
            next: string | null;
            previous: string | null;
        }>('/store/products/advanced_search/', { params });
        return response.data;
    },

    // Get available categories for filtering
    getSearchCategories: async () => {
        const response = await apiClient.get<string[]>('/store/products/search_categories/');
        return response.data;
    },

    // Quick search for autocomplete
    quickSearch: async (query: string, limit: number = 5) => {
        const response = await apiClient.get<SearchResult[] | {
            results: SearchResult[];
            count: number;
            next: string | null;
            previous: string | null;
        }>('/store/products/advanced_search/', {
            params: { q: query, page_size: limit }
        });

        // Handle both response formats
        const data = response.data;

        if (Array.isArray(data)) {
            return data.slice(0, limit); // Direct array response
        } else if (data && data.results) {
            return data.results.slice(0, limit); // Paginated response
        } else {
            return []; // Fallback
        }
    }
};